import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Show } from "../../../../hooks/Show";
import { SubCategoryModalForm } from "./SubCategoryModalForm";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";

const HeaderSubCategoriesComponent = ({
  successfulCreateSubCategory = false,
  reduxCreateSubCategories = () => {},
}) => {
  const [openModalCreateSubCategory, setOpenModalCreateSubCategory] =
    useState(false);

  const methods = useForm();

  const isAvailableToSubmit =
    methods.watch("categoryId") &&
    methods.watch("subCategoryCode") &&
    methods.watch("subCategoryName");

  const handleCreateSubCategory = (data) => {
    reduxCreateSubCategories({
      idCategory: data.categoryId,
      subCategoryCode: data.subCategoryCode,
      subCategoryName: data.subCategoryName.trim(),
    });
  };

  const handleOpenModalCreateSubCategory = () => {
    setOpenModalCreateSubCategory(true);
  };
  const handleCloseModalCreateSubCategory = () => {
    setOpenModalCreateSubCategory(false);
    methods.reset();
  };

  useEffect(() => {
    if (successfulCreateSubCategory) {
      methods.reset();
      setOpenModalCreateSubCategory(false);
    }
  }, [successfulCreateSubCategory]);
  return (
    <>
      <div className="d-sm-flex align-items-center mb-1 align-items-center justify-content-between">
        <h1 className="h3 mb-0 text-gray-800 mr-3">Subcategorías</h1>
        <Show when="feature:wms-subcategories-create">
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleOpenModalCreateSubCategory}
          >
            Crear subcategoría <i className="fas fa-plus fa-sm"></i>
          </button>
        </Show>
      </div>
      <p className="mb-4">Módulo de Administración de subcategorías</p>
      <Modal
        size="lg"
        show={openModalCreateSubCategory}
        onHide={handleCloseModalCreateSubCategory}
        onEscapeKeyDown={handleCloseModalCreateSubCategory}
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Crear Subcategoría</Modal.Title>
        </Modal.Header>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleCreateSubCategory)}>
            <Modal.Body>
              <SubCategoryModalForm />
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseModalCreateSubCategory}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={!isAvailableToSubmit}
              >
                Crear Subcategoría
              </Button>
            </Modal.Footer>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    successfulCreateSubCategory:
      state.subCategoriesState.successfulCreateSubCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxCreateSubCategories: (payload) =>
      dispatch({
        type: "CREATE_SUB_CATEGORY_REQUEST",
        value: payload,
      }),
  };
};

export const HeaderSubCategories = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderSubCategoriesComponent);
